import type { PropsWithChildren } from "react";
import { Link, type LinkProps } from "@tanstack/react-router";
import { tv } from "tailwind-variants";

import { focusRing, icons } from "@/ui";

const extraNavBarItemVariants = tv({
  slots: {
    /* my-1.5 keeps the hover plate clear of the dividers above and below it. */
    link: [
      "group flex min-h-14 items-center justify-between gap-4 rounded-card px-4 py-4 text-lg font-semibold sm:px-5",
      "my-1.5 transition-colors duration-200 hover:bg-surface-hover hover:text-accent",
      focusRing,
    ],
    chevron:
      "size-5 shrink-0 text-content-muted transition-transform duration-200 group-hover:translate-x-1 group-hover:text-accent",
  },
});

const { chevron, link } = extraNavBarItemVariants();

type ExtraNavBarItemProps = LinkProps & {
  className?: string;
  onClick?: () => void;
};

export const ExtraNavBarItem = ({
  children,
  className,
  ...props
}: PropsWithChildren<ExtraNavBarItemProps>) => {
  return (
    <li className="border-b border-line">
      <Link className={link({ className })} {...props}>
        {children}
        <icons.ChevronRightIcon aria-hidden="true" className={chevron()} />
      </Link>
    </li>
  );
};
